import { ajax, } from "./ajax";
import { LoginEntity } from "../entity/LoginEntity";
import * as es6promise from "es6-promise";
import { set } from "vue/types/umd";
import { ui } from "./ui";
import { retailerConfig } from "../entity";

declare var gigya: any;
declare var gigyaUtil: any;

export module dialogUtil {

	/**
	 * 
	 * ダイアログ系
	 * ダイアログを作成し、メッセージとボタン押下時の処理を外から設定する。
	 * 
	 * */

	export enum DialogType {
		Infomation, //0
		Warning,    //1
		None,       //2
	}

	/**
	 * インフォメーションダイアログを作成します。
	 * @param msg   文言
	 * @param func  OK時のファンクション
	 * @param type  アイコンのタイプ(デフォルトInfomation)
	 * @param noBtn OKボタンを表示しない。
	 */
	export function createErrorDialog(msg: string, func: Function, type?: DialogType, noBtn?: boolean): void {
		const isPC = ui.usePcDesign();

		let body = $("body");
		body.removeClass().addClass("anmDialog");

		// ヘッダーとメッセージを束ねるsection
		let dialogParent = $("#errorDlg");

		$("#errorDlg").addClass("is-information");

		$("#errorDlg").addClass("c-modalDialog__panel--hasClose");

		if ($("#OKDialog").length == 0) {
			let section = $('<section>').attr("class", "c-modalDialog__content u-positionOrigin").attr("id", "OKDialog");

			// ヘッダー部
			let header = $('<header>').attr("id", "errorDialogHeader").attr("class", "c-modalDialog__header is-hidden");
			if (!isPC) header.removeClass("is-hidden");
			let h1 = $('<h1>').attr("id", "errorTitle").attr("class", "dlgHeader").text("ご確認ください");
			header.append(h1);
			section.append(header);

			// メッセージ部
			let divP = $("<div>").attr("class", "c-modalDialog__body");
			let divIcon;
			if (isPC) {
				// インフォメーションアイコン
				divIcon = $("<div>").attr("id", "errorDialogIcon").attr("class", "c-modalDialog__message is-information");

				if (type == DialogType.Warning) {
					// ワーニング
					divIcon = $("<div>").attr("id", "errorDialogIcon").attr("class", "c-modalDialog__message is-attention");

				} else if (type == DialogType.None) {
					// アイコンなし
					divIcon = $("<div>").attr("id", "errorDialogIcon").attr("class", "c-modalDialog__message");
				}
			} else {
				divIcon = $("<div>").attr("id", "errorDialogIcon").attr("class", "c-modalDialog__message");
            }
			divP.append(divIcon);

			//let divM = $("<div>").attr("id", "errorDialogIcon").attr("class", "c-modalDialog__message");

			// 　Xボタン -> このダイアログでは不要
			/*let divB = $("<div>").attr("id", "closeBtnOnErrorDialog").attr("class", "c-modalDialog__closeBtn").click(func);*/
			//divP.append(divM);
			/*divP.append(divB);*/
			section.append(divP);

			// フッター 
			let footer = $("<footer>").attr("class", "c-modalDialog__footer t-footer");
			if (!noBtn) {
				let buttonOK = $("<button>").attr("id", "okBtn").attr("class", "c-modalDialog__footerBtn t-btn").text("OK");
				footer.append(buttonOK);
			}
			section.append(footer);

			dialogParent.append(section);
		}

		$("#errorDlg").show();

		// 関数の追加
		$(document).off('#okBtn');
		$(document).on('click', '#okBtn', () => { func() });

		// メッセージの定義
		$("#errorDialogIcon").html(msg);

	}
	export function closeErrorDialog(): void {
		/*alert("OKボタンイベント");*/
		let body = $("body");
		body.removeClass().removeClass("anmDialog");

		$("#errorDlg").removeClass("c-modalDialog__panel--hasClose");
	}

	/**
	 * YES/NOダイアログを作成します。
	 * @param msg   文言
	 * @param okFunc	YES時のファンクション
	 * @param ngFunc	NO時のファンクション
	 * @param yesCapton	YESボタンのキャプション
	 * @param noCapton  NOボタンのキャプション
	 * @param type		アイコンのタイプ(デフォルトInfomation)
	 */
	export function createYesNoDialog(msg: string, yesFunc: Function, noFunc: Function, yesCapton: string, noCapton: string, type?: DialogType): void {
		const isPC = ui.usePcDesign();

		let body = $("body");
		body.removeClass().addClass("anmDialog");

		// ヘッダーとメッセージを束ねるsection
		let dialogParent = $("#yesNoDlg");

		$("#yesNoDlg").addClass("is-information");

		$("#yesNoDlg").addClass("c-modalDialog__panel--hasClose");

		if ($("#yesNoDialog").length == 0) {
			let section = $('<section>').attr("class", "c-modalDialog__content u-positionOrigin").attr("id", "yesNoDialog");

			// ヘッダー部
			let header = $('<header>').attr("id", "yesNoDialogHeader").attr("class", "c-modalDialog__header is-hidden");
			if (!isPC) header.removeClass("is-hidden");
			let h1 = $('<h1>').attr("id", "yesNoTitle").attr("class", "dlgHeader").text("ご確認ください");
			header.append(h1);
			section.append(header);

			// メッセージ部
			let divP = $("<div>").attr("class", "c-modalDialog__body");

			let divIcon;
			if (isPC) {
				// インフォメーションアイコン
				divIcon = $("<div>").attr("id", "yesNoDialogIcon").attr("class", "c-modalDialog__message is-information");

				if (type == DialogType.Warning) {
					// ワーニング
					divIcon = $("<div>").attr("id", "yesNoDialogIcon").attr("class", "c-modalDialog__message is-attention");

				} else if (type == DialogType.None) {
					// アイコンなし
					divIcon = $("<div>").attr("id", "yesNoDialogIcon").attr("class", "c-modalDialog__message");
				}
			} else {
				divIcon = $("<div>").attr("id", "yesNoDialogIcon").attr("class", "c-modalDialog__message");
            }

			divP.append(divIcon);
			section.append(divP);

			// フッター
			let footer = $("<footer>").attr("class", "c-modalDialog__footer t-footer");
			let buttonNO = $("<button>").attr("id", "yesNoDlg_noDBtn").attr("class", "c-modalDialog__footerBtn t-btn").text(noCapton ? noCapton : "キャンセル");
			let buttonYES = $("<button>").attr("id", "yesNoDlg_yesDBtn").attr("class", "c-modalDialog__footerBtn t-btn").text(yesCapton ? yesCapton : "OK");
			footer.append(buttonNO);
			footer.append(buttonYES);
			section.append(footer);

			dialogParent.append(section);
		}

		// 関数の追加
		$('#yesNoDlg_yesDBtn').off('click');
		$('#yesNoDlg_yesDBtn').on('click', () => { yesFunc() });

		$('#yesNoDlg_noDBtn').off('click');
		$('#yesNoDlg_noDBtn').on('click', () => { noFunc() });

		// メッセージの定義
		$("#yesNoDialogIcon").html(msg);

		$("#yesNoDlg").show();
	}
	export function closeYesNoDialog(): void {
		/*alert("OKボタンイベント");*/
		let body = $("body");
		body.removeClass().removeClass("anmDialog");

		$("#yesNoDlg").removeClass("c-modalDialog__panel--hasClose");
	}

	/**
	 * 保存上書き確認ダイアログを作成します。
	 * @param msg   文言
	 * @param func  OK時のファンクション
	 * @param type  アイコンのタイプ(デフォルトInfomation)
	 */
	export function createCheckSaveDialog(): es6promise.Promise<any> {

		return new es6promise.Promise((res, rej) => {
			const isPC = ui.usePcDesign();
			let body = $("body");
			body.removeClass().addClass("anmDialog");

			// ヘッダーとメッセージを束ねるsection
			let DlgName = "#saveOverRideDlg"
			let dialogParent = $(DlgName);

			$(DlgName).addClass("is-information");

			$(DlgName).addClass("c-modalDialog__panel--hasClose");

			if ($("#OverRideOKDialog").length == 0) {
				let section = $('<section>').attr("class", "c-modalDialog__content u-positionOrigin").attr("id", "OverRideOKDialog");

				// ヘッダー部
				let header = $('<header>').attr("id", "saveOverRideDialogHeader").attr("class", "c-modalDialog__header is-hidden");
				if (!isPC) header.removeClass("is-hidden");
				let h1 = $('<h1>').attr("id", "saveOverRideTitle").attr("class", "dlgHeader").text("ご確認ください");
				header.append(h1);
				section.append(header);

				// メッセージ部
				let divP = $("<div>").attr("class", "c-modalDialog__body");


				if (isPC) { 
					// インフォメーションアイコン
					let divIcon = $("<div>").attr("id", "saveOverRideDialogIcon").attr("class", "c-modalDialog__message is-information");
					divP.append(divIcon);
				}

				let divM = $("<div>").attr("id", "saveOverRideDialogIcon").attr("class", "c-modalDialog__message");

				divP.append(divM);
				section.append(divP);

				// フッター
				let footer = $("<footer>").attr("class", "c-modalDialog__footer t-footer");
				let buttonOK = $("<button>").attr("id", "okOverRideBtn").attr("class", "c-modalDialog__footerBtn t-btn").text("はい");
				let buttonNO = $("<button>").attr("id", "noOverRideBtn").attr("class", "c-modalDialog__footerBtn t-btn").text("いいえ");
				footer.append(buttonNO);
				footer.append(buttonOK);
				section.append(footer);

				dialogParent.append(section);
			}

			$(DlgName).show();

			// 関数の追加
			$("#okOverRideBtn").off();
			$("#okOverRideBtn").click(() => {
				closeCheckSaveDialog();
				res();
			});

			// 関数の追加
			$("#noOverRideBtn").off();
			$("#noOverRideBtn").click(() => {
				closeCheckSaveDialog();
				rej();
			});

			// メッセージの定義
			$("#saveOverRideDialogIcon").html("同じ名前の保存データが存在します。上書きしますか？");
		});

	}

	export function closeCheckSaveDialog(): void {
		let body = $("body");
		body.removeClass().removeClass("anmDialog");
		$("#saveOverRideDlg").removeClass("c-modalDialog__panel--hasClose");
	}

	/**
	 * 保存ダイアログ作成(保存名入力)
	 * @param okFunc
	 * @param cancelFunc
	 */
	export function createSaveDialog(): es6promise.Promise<any> {
		const isPC = ui.usePcDesign();

		return new es6promise.Promise((res, rej) => {
			let body = $("body");
			body.removeClass().addClass("anmDialog");

			// ヘッダーとメッセージを束ねるsection
			let dialogParent = $("#saveAsDlg");

			$("#saveAsDlg").addClass("c-modalDialog__panel--hasClose");

			if ($("#saveDialog").length == 0) {

				let section = $('<section>').attr("class", "c-modalDialog__content").attr("id", "saveDialog");

				// ヘッダー部
				if (!isPC) {
					let header = $('<header>').attr("class", "c-modalDialog__header");
					let h1 = $('<h1>').attr("id", "saveAsDialogTitle").text("ご確認ください");
					h1.addClass('dlgHeader');
					header.append(h1);
					section.append(header);
				}

				let divP = $("<div>").attr("class", "c-modalDialog__body c-modalDialog__body--inputText");

				// メッセージ部
				let div1 = $("<div>").attr("class", "c-modalDialog__message c-modalDialog__message--inputText");
				let p = $("<p>").attr("id", "saveAsDialogDescription").text("編集データを保存します。保存する名前を入力してください。");
				div1.append(p);

				// メッセージ部２
				let div2 = $("<div>").attr("class", "c-modalDialog__input--inputText");
				let dl = $("<dl>").attr("class", "c-labelAndForm c-labelAndForm--inputDialog");
				let dt = $("<dt>").attr("id", "saveAsDialogDataNameTitle").attr("class", "c-labelAndForm__label c-labelAndForm__label--inputDialog").text("データ名:");
				let dd = $("<dd>").attr("class", "c-labelAndForm__input c-labelAndForm__input--inputDialog");
				let input = $("<input>").attr("id", "saveName").attr("type", "text").attr("placeholder", "データ名を記入してください。").attr("maxlength","100");
				dd.append(input);
				dl.append(dt);
				dl.append(dd);
				div2.append(dl);

				divP.append(div1);
				divP.append(div2);

				// フッター
				let footer = $("<footer>").attr("class", "c-modalDialog__footer t-footer");
				let buttonCancel = $("<button>").attr("id", "cancelBtnOnSaveAsDialog").attr("class", "c-modalDialog__footerBtn t-btn").text("キャンセル");
				let buttonOK = $("<button>").attr("id", "okBtnOnSaveAsDialog").attr("class", "c-modalDialog__footerBtn t-btn is-disabled").text("OK");

				footer.append(buttonCancel);
				footer.append(buttonOK);

				section.append(divP);
				section.append(footer);

				dialogParent.append(section);
			}

			// 前回入力削除
			$('#saveName').val('');

			// 関数の追加
			// キャンセル押下時
			$('#cancelBtnOnSaveAsDialog').off();
			$("#cancelBtnOnSaveAsDialog").click(() => {
				// キャンセル時は空文字を返す。
				res('');
			});

			// OK押下時
			$("#okBtnOnSaveAsDialog").off();
			$("#okBtnOnSaveAsDialog").click(() => {
				// 名前だけ返す。
				res($('#saveName').val());
			});

			// ボタン入力制御
			$('#okBtnOnSaveAsDialog').addClass('is-disabled');
			$('#saveName').off();
			$('#saveName').keyup(() => {
				const saveAs = $('#saveName').val();
				if (saveAs.length > 0) {
					$('#okBtnOnSaveAsDialog').removeClass('is-disabled');
				} else {
					$('#okBtnOnSaveAsDialog').addClass('is-disabled');
				}
			})
		});
	}

	/**
	 * 保存ダイアログ閉じる
	 * @param msg
	 * @param func
	 */
	export function closeSaveDialog(): void {
		let body = $("body");
		body.removeClass("anmDialog");

		$("#saveAsDlg").removeClass("c-modalDialog__panel--hasClose");
	}

	/**
	 * 上書き保存か、別名保存かユーザに選択させるダイアログ
	 * */
	export function createSelectSaveMethodDialog(overRideFunc: Function, otherNameFunc: Function): es6promise.Promise<any> {
		// PCかどうか
		const isPC = ui.usePcDesign();

		return new es6promise.Promise((res, rej) => {
			let body = $("body");
			body.removeClass().addClass("anmDialog");

			// ヘッダーとメッセージを束ねるsection
			let DlgName = "#selectSaveMethodDlg"
			let dialogParent = $(DlgName);

			$(DlgName).addClass("is-information");

			$(DlgName).addClass("c-modalDialog__panel--hasClose");

			if ($("#selectSaveMethodDialog").length == 0) {
				let section = $('<section>').attr("class", "c-modalDialog__content u-positionOrigin").attr("id", "selectSaveMethodDialog");
				// ヘッダー部
				if (!isPC) {
					const divH = $("<div>").attr("class", "c-modalDialog__header").text("ご確認ください");
					section.append(divH);
                }

				// メッセージ部
				let divP = $("<div>").attr("class", "c-modalDialog__body");

				// インフォメーションアイコン
				let dlgMsg = "設定内容の保存<br><br>保存方法を選択してください。";
				dlgMsg += "<br>保存せずに編集画面に戻る場合は<span class=\"is-emphasized\">[×]</span>ボタンを押してください。";
				let divIcon = $("<div>").attr("id", "selectSaveMethodDialogIcon").attr("class", "c-modalDialog__message is-information").html(dlgMsg);
				divP.append(divIcon);

				// ×ボタン
				let divXbutton = $("<div>");
				let label = $("<label>").attr("id", "closeBtnOnErrorDialog").attr("class", "c-modalDialog__closeBtn").text("閉じる");
				divXbutton.append(label);
				divP.append(divXbutton);

				section.append(divP);

				// フッター
				let footer = $("<footer>").attr("class", "c-modalDialog__footer t-footer");
				let buttonOK = $("<button>").attr("id", "selectOtherNameBtn").attr("class", "c-modalDialog__footerBtn t-btn").text("別名で保存する");
				let buttonNO = $("<button>").attr("id", "selectOverRideBtn").attr("class", "c-modalDialog__footerBtn t-btn").text("上書き保存する");
				footer.append(buttonNO);
				footer.append(buttonOK);
				section.append(footer);

				dialogParent.append(section);
			}

			$(DlgName).show();

			// 関数の追加
			$("#selectOtherNameBtn").off();
			$("#selectOtherNameBtn").click(() => {
				otherNameFunc();
				res();
			});
			$("#selectOverRideBtn").off();
			$("#selectOverRideBtn").click(() => {
				overRideFunc();
				res();
			});

			// ｘボタン
			$("#closeBtnOnErrorDialog").off();
			$("#closeBtnOnErrorDialog").click(() => {
				dialogUtil.closeSelectSaveMethodDialog();
				dialogUtil.closeLoading();
			});
		});

	}

	/**
	 * 上書き保存か、別名保存かユーザに選択させるダイアログ
	 */
	export function closeSelectSaveMethodDialog(): void {
		let body = $("body");
		body.removeClass("anmDialog");

		$("#selectSaveMethodDlg").removeClass("c-modalDialog__panel--hasClose");
	}

	/**
	 * 上書き保存か、別名保存かユーザに選択させるダイアログ(画面遷移時の警告)
	 * @param isEdit 一度でも保存していればtrue
	 * @param isLogined ログイン済みであれば true
	 * @param overRideFunc 上書き処理(isEditがtrueの場合はボタン表示しない。)
	 * @param otherNameFunc 名前を付けて保存処理
	 * @param nopFunc 何もしない(デザイン選択画面へ)
	 */
	export function createCautionSelectSaveMethodDialog(isEdit: boolean, isLogined: boolean, overRideFunc: Function, otherNameFunc: Function, nopFunc: Function): void {
		const isPC = ui.usePcDesign();

		let body = $("body");
		body.removeClass().addClass("anmDialog");

		// ヘッダーとメッセージを束ねるsection
		let DlgName = "#cautionSelectSaveMethodDlg"
		let dialogParent = $(DlgName);

		$(DlgName).addClass("is-information");

		$(DlgName).addClass("c-modalDialog__panel--hasClose");

		if ($("#cautionSelectSaveMethodDialog").length == 0) {
			let section = $('<section>').attr("class", "c-modalDialog__content u-positionOrigin").attr("id", "cautionSelectSaveMethodDialog");

			if (!isPC) {
				const divH = $("<div>").attr("class", "c-modalDialog__header").text("ご確認ください");
				section.append(divH);
            }

			// メッセージ部
			let divP = $("<div>").attr("class", "c-modalDialog__body");

			// インフォメーションアイコン
			let dlgMsg = "編集データを保存していない場合、データが失われます。<br>再び編集する場合は、保存してください。";
			dlgMsg += "<br><br>編集画面に戻る場合は[×]ボタンを押してください。";
			let divIcon = $("<div>").attr("id", "cautionSelectSaveMethodDialogIcon").attr("class", "c-modalDialog__message is-attention").html(dlgMsg);
			divP.append(divIcon);

			// ×ボタン
			let divXbutton = $("<div>");
			let label = $("<label>").attr("id", "closeBtnOnErrorDialog").attr("class", "c-modalDialog__closeBtn").text("閉じる");
			divXbutton.append(label);
			divP.append(divXbutton);

			section.append(divP);

			// フッター
			let footer = $("<footer>").attr("class", "c-modalDialog__footer t-footer");
			let buttonOK = $("<button>").attr("id", "cautionSelectOtherNameBtn").attr("class", "c-modalDialog__footerBtn t-btn").text("別名で保存する");
			let buttonNO = $("<button>").attr("id", "cautionSelectOverRideBtn").attr("class", "c-modalDialog__footerBtn t-btn").text("上書き保存する");
			let buttonNOP = $("<button>").attr("id", "cautionSelectNOPBtn").attr("class", "c-modalDialog__footerBtn t-btn").text("保存しない");
			footer.append(buttonNO);
			footer.append(buttonOK);
			footer.append(buttonNOP);
			section.append(footer);

			dialogParent.append(section);
		}

		// 出すボタン/文言の制御
		if (isLogined) {
			// ログイン済みの場合
			if (isEdit) {
				// 再編集
				let dlgMsg = "編集データを保存していない場合、データが失われます。<br>再び編集する場合は、保存してください。";
				dlgMsg += "<br><br>編集画面に戻る場合は[×]ボタンを押してください。";
				$("#cautionSelectSaveMethodDialogIcon").html(dlgMsg)
				$("#cautionSelectOtherNameBtn").text("別名で保存する");
				$("#cautionSelectOverRideBtn").text("上書き保存する");
				$("#cautionSelectOverRideBtn").removeClass("is-hidden");
				$("#cautionSelectNOPBtn").text("保存しない");
			} else {
				// 新規
				let dlgMsg = "編集データが保存されていません。<br>再び編集する場合は、保存してください。";
				dlgMsg += "<br><br>編集画面に戻る場合は[×]ボタンを押してください。";
				$("#cautionSelectSaveMethodDialogIcon").html(dlgMsg)
				$("#cautionSelectOtherNameBtn").text("名前を付けて保存する");
				$("#cautionSelectOverRideBtn").addClass("is-hidden");
				$("#cautionSelectNOPBtn").text("保存しない");
			}
		}
		else {
			// 上記以外の場合
			let dlgMsg = "編集操作を終了してよろしいですか？<br>ゲスト利用では、終了すると、編集データが失われます。";
			dlgMsg += "<br><br>編集画面に戻る場合は[×]ボタンを押してください。" ;
			$("#cautionSelectSaveMethodDialogIcon").html(dlgMsg)
			$("#cautionSelectOtherNameBtn").addClass("is-hidden");
			$("#cautionSelectOverRideBtn").addClass("is-hidden");
			$("#cautionSelectNOPBtn").text("はい(終了する)");
		}

		// 表示するボタンが３つある場合はクラスを追加
		if ($('#cautionSelectSaveMethodDialog .c-modalDialog__footer button.is-hidden').length) {
			$('.c-modalDialog__footerBtn').removeClass('tripleBtn');
		} else {
			$('.c-modalDialog__footerBtn').addClass('tripleBtn');
        }

		$(DlgName).show();

		// 関数の追加
		$("#cautionSelectOtherNameBtn").off();
		$("#cautionSelectOtherNameBtn").click(() => {
			otherNameFunc();
		});

		$("#cautionSelectOverRideBtn").off();
		$("#cautionSelectOverRideBtn").click(() => {
			overRideFunc();
		});

		$("#cautionSelectNOPBtn").off();
		$("#cautionSelectNOPBtn").click(() => {
			nopFunc();
		});

		// ｘボタン
		$("#closeBtnOnErrorDialog").off();
		$("#closeBtnOnErrorDialog").click(() => {
			dialogUtil.closeCautionSelectSaveMethodDialog();
			dialogUtil.closeLoading();
		});	
	}

	/**
	 * 上書き保存か、別名保存かユーザに選択させるダイアログ
	 */
	export function closeCautionSelectSaveMethodDialog(): void {
		let body = $("body");
		body.removeClass("anmDialog");

		$("#cautionSelectSaveMethodDlg").removeClass("c-modalDialog__panel--hasClose");
	}


	/**
	 * コマースクラウドと連携したときに出すダイアログ
	 * @param saveDate
	 * @param expireDate
	 */
	export function createSaveDoneDialog(saveAs: string, saveDate: string, expireDate: string, func: Function): void {
		const isPC = ui.usePcDesign();

		let body = $("body");
		body.removeClass().addClass("anmDialog");

		// メッセージ部(PCとSPで表示する文言を変える。)
		let msg = "";
		if (isPC) {
			msg = "画面上部の「編集中一覧/注文履歴」からご確認いただけます。";
		} else {
			msg = "サイトトップ右上にある[保存データから開く]ボタンから開くことができます。";
		}


		// ヘッダーとメッセージを束ねるsection
		let dialogParent = $("#saveDoneDlg");
		$(dialogParent).addClass("c-modalDialog__panel--hasClose popupContent");

		if ($("#saveDoneDialog").length == 0) {

			let section = $('<section>').attr("class", "c-modalDialog__content").attr("id", "saveDoneDialog");

			// ヘッダー部
			if (isPC) {
				const h3 = $('<h3>').attr('class', 'popupContentTitle').text('ご確認ください');
				const span = $('<span>').attr('class', 'popupContentIcon');
				h3.append(span);
				section.append(h3);
			} else {
				const divH = $('<div>').attr('class', 'c-modalDialog__header').text('ご確認ください');
				section.append(divH);
            }

			// コンテント
			const Content = $('<div>').attr('class', 'popupContentContentArea');
			const h1 = $('<h1>').attr('class', 'popupiContent').text('データを保存しました');
			Content.append(h1);

			const contentDiv = $('<div>').attr('class', 'frameComplete');
			const label = $('<p>').attr('class', 'lebe').text(msg);
			contentDiv.append(label);

			const dl = $('<dl>').attr('class', 'result');
			const dt = $('<dt>').attr('id', 'saveDoneSaveAs')
			dl.append(dt);

			const dd1 = $('<dd>').attr('id', 'saveDoneSaveDate');
			const dd2 = $('<dd>').attr('id', 'saveDoneExpireDate');
			dl.append(dd1);
			dl.append(dd2);
			contentDiv.append(dl);
			Content.append(contentDiv);

			section.append(Content);

			// フッター(ボタン)
			// フッター
			let footer = $("<footer>").attr("class", "c-modalDialog__footer t-footer");
			let buttonOK = $("<button>").attr("id", "okBtnOnSaveDoneDialog").attr("class", "c-modalDialog__footerBtn t-btn").text("閉じる");
			footer.append(buttonOK);
			section.append(footer);

			dialogParent.append(section);
		}

		// 文言の更新
		$('#saveDoneSaveAs').text("保存名：" + saveAs);
		$('#saveDoneSaveDate').text("保存日時：" + saveDate);
		$('#saveDoneExpireDate').text("保存期限：" + expireDate);

		// 関数の追加
		// OK押下時
		$('#okBtnOnSaveDoneDialog').off();
		$("#okBtnOnSaveDoneDialog").click(() => {
			// 閉じる処理
			let body = $("body");
			body.removeClass("anmDialog");
			$(dialogParent).removeClass("c-modalDialog__panel--hasClose popupContent");
			if (func) {
				func();
			}
		});

	}

	/**
	 * 
	 * ローディング系
	 * 
	 * */
	// ローディング表示
	export function showLoading() {
		$("#dialogWrapper").addClass("dialogWrapper");

		$("#loadingDialog").removeClass("non-loader");
		$("#loadingDialog").addClass("loader");
	}

	// ローディング非表示
	export function closeLoading() {
		$("#dialogWrapper").removeClass("dialogWrapper");

		$("#loadingDialog").removeClass("loader");
		$("#loadingDialog").addClass("non-loader");
	}

	///**
	// * GIGYAのログインダイアログ
	// */

	//export function showGIGYA() {
	//	// 未ログイン -> ログインダイアログ表示
	//	// gigya のダイアログ
	//	gigya.accounts.showScreenSet({
	//		screenSet: 'printsgifts-RegistrationLogin',
	//		containerID: '',
	//		startScreen: 'gigya-login-screen',
	//		//authFlow: 'redirect', // LINEアカウントによる新規登録を行うため必須のパラメータ
	//		lang: 'ja'
	//	});
	//}

	/*
	 * OCAPIのログインダイアログ
	 **/
	export function showOCAPIDialog(conf: retailerConfig.ocapi): es6promise.Promise<any> {
		const isPC = ui.usePcDesign();

		return new Promise((res, rej) => {

			let body = $("body");
			body.removeClass().addClass("anmDialog");

			// ダイアログ作成準備
			if ($('#ocapi_login_dlg')[0] == undefined) {

				let section = $('<section>').attr("class", "c-modalDialog__content u-positionOrigin").attr("id", "OCAPIDialog");
				// ヘッダー部
				if (!isPC) { 
					let header = $('<header>').attr("id", "ocapi_login_dlg_header").attr("class", "c-modalDialog__header");
					let h1 = $('<h1>').attr("id", "saveOverRideTitle").attr("class", "dlgHeader").text("会員のお客様");
					header.append(h1);
					section.append(header);
				}

				// dialogはFireFox,IE非対応のため他のダイアログに合わせてdiv形式にする
				var OCAPILoginDialog =
					'<div id="ocapi_login_dlg" class="c-modalDialog__body">'
					+ '	<div class="c-modalDialog__message">'
					+ ' <div class="c-modalDialog__message__body">'
					+ ' <div class="closeBtn_area">'
					+ '<label id="closeBtnOnErrorDialog" class="c-modalDialog__closeBtn">閉じる</label>'
					+ ' </div>'
					+ '		<h3 class="subttl" style="font-weight: bold;">会員のお客様</h3>'
					+ '		<p class="requiredMsg">「<span style="color:red;">※</span>」は入力必須項目です</p>'
					+ '     <div class="errList">'
					+ '       <ul>'
					+ '         <li>'
					+ '           <a>申し訳ございませんが、入力された内容が保存されている記録と一致しません。入力内容に間違いがないかご確認の上、もう一度お試しください。</a>'
					+ '         </li>'
					+ '       </ul>'
					+ '     </div>'
					+ '		<div class="required">'
					+ '			<p>Ｅメールアドレス　'
					+ '				<span style="color:red;">※</span>'
					+ '			</p>'
					+ '			<input class="requiredTxt" autocomplete="on" type="email" name="email" id="ocapi_email" placeholder="例) yamada.tarou@example.co.jp" />'
					+ '			<span id="emailCaution">「※」は入力必須項目です。</span>'
					+ '		</div>'
					+ '		<div class="required">'
					+ '			<p>パスワード　'
					+ '				<span style="color:red;">※</span>'
					+ '			</p>'
					+ '			<input class="requiredTxt" autocomplete="on" type="password" name="password" id="ocapi_password" />'
					+ '			<span id="passwordCaution">「※」は入力必須項目です。</span>'
					+ '		</div>'
					//+ '		<div class="checkbox">'
					//+ '			<label class="remenberLabel">'
					//+ '				<input type="checkbox"><span class="remenberSelect">このアカウントを記憶する</span></input>'
					//+ '			</label>'
					//+ '		</div>'
					+ '		</div>'
					+ '		<div id="ocapi_login_dlg_footer" class="c-modalDialog__footer ocapi_login_footer">'
					+ '			<button id="close">ログイン</button>'
					+ '			<button id="regist" class="registLabel">今すぐ会員登録する</button>'
					+ '		</div>'
					+ '		<div class="buttons">'
					+ '         <div class="forgotArea">'
					+ '             <div class="forgotAllow"></div>'
					+ '             <a id="forgot" class="forgotLabel" > パスワードをお忘れの方</a>'
					+ '         </div>'
					+ '		</div>'
					+ '	</div>'
					+ '</div>';

				$(OCAPILoginDialog).appendTo(section);
				$(section).appendTo("#OCAPILoginDialog");

				if (isPC) {
					$('#ocapi_login_dlg').addClass('login_form_pc');
					$('#ocapi_login_dlg_footer').removeClass('c-modalDialog__footer');
				} else {
					$('.subttl').addClass('is-hidden');
				}

			} else {
				// 内容初期化
				$('#ocapi_email').val('');
				$('#ocapi_password').val('');
			}

			// イベント登録
			// ダイアログ作成時にイベント登録するとPromiseが返ってこないので、ここでイベントのoff/onをする。
			$('#close').off('click');
			$('#close').on('click', function () {
				let loginid = $('#ocapi_email').val();
				let pass = $('#ocapi_password').val();

				if (!loginid) {
					$('#ocapi_email').focus();
					return;
				} else if (!pass) {
					$('#ocapi_password').focus();
					return;
				}

				let model = {
					loginId: loginid,
					password: pass,
				}
				res(model);
			});

			// 新規登録
			$('#regist').off('click');
			$('#regist').on('click', function () {
				window.open(conf.regist);
			});

			// パスワード忘れ
			$('#forgot').off('click');
			$('#forgot').on('click', function () {
				window.open(conf.forgotPassword);
			});

			// email入力チェック
			$('#ocapi_email').off('blur');
			$('#ocapi_email').on('blur', function () {
				var email = $('#ocapi_email').val();
				if (email) {
					console.log('email is not empty');
					$('#emailCaution').css('display', 'None');
				} else {
					// 空
					console.log('email is empty');
					$('#emailCaution').css('display', 'Block');
				}

			});

			// パスワード入力チェック
			$('#ocapi_password').off('blur');
			$('#ocapi_password').on('blur', function () {
				var pass = $('#ocapi_password').val();
				if (pass) {
					console.log('password is not empty');
					$('#passwordCaution').css('display', 'None');
				} else {
					console.log('password is empty');
					$('#passwordCaution').css('display', 'Block');
				}
			});

			$('#closeBtnOnErrorDialog').off('click');
			$('#closeBtnOnErrorDialog').on('click', closeOCAPI);

			$("#OCAPILoginDialog").addClass("c-modalDialog__panel--hasClose");
		});

	}
	/**
	 * OCAPIのダイアログ閉じ
	 * */
	export function closeOCAPI(): void {
		$("#OCAPILoginDialog").removeClass("c-modalDialog__panel--hasClose");
		$('body').removeClass('anmDialog');
		dialogUtil.closeLoading();
	}
	/**
	 * OCAPIのエラーメッセージ表示(固定文言)
	 * */
	export function showLoginFailedMessageOCAPI() {
		$('.errList').css('display', 'Block');
		$('.login_form_pc').css('max-height', '460px');
	}

	export function showMyStampHowToDlg(usePc: boolean, okFunc: Function, cancelFunc: Function): es6promise.Promise<any> {

		return new es6promise.Promise((res, rej) => {
			let body = $("body");
			body.removeClass().addClass("anmDialog");

			// ヘッダーとメッセージを束ねるsection
			let dialogParent = $("#myStampHowToDlg");

			$("#myStampHowToDlg").addClass("is-information");
			$("#myStampHowToDlg").addClass("c-modalDialog__panel--hasClose");
			if (!usePc) {
				$("#myStampHowToDlg").addClass("myStampDialog");
			}

			if ($("#myStampHowToOKDialog").length == 0) {
				let section = $('<section>').attr("class", "c-modalDialog__content u-positionOrigin").attr("id", "myStampHowToOKDialog");
				// ヘッダー部
				const headerMsg = "写真スタンプ機能のご紹介";
				if (usePc) {
					const h3 = $('<h3>').attr('class', 'popupContentTitle').text(headerMsg);
					const span = $('<span>').attr('class', 'popupContentIcon');
					h3.append(span);
					section.append(h3);
				} else {
					const header = $('<header>').attr("class", "c-modalDialog__header font_size_change").text(headerMsg);
					section.append(header)
                }

				// メッセージ部
				let divMes = $("<div>").attr("class","popupContentContentAreaHowTo");
				let divMesHead = $("<p>").attr("class", "popupContent__contentArea__topMsg").html("ご自身で用意した画像やイラストデータを自由にレイアウトできます。<br>(PNG,JPEGファイルに対応。アップロード上限は50枚です。)");

				let divImg = $("<img>").attr("class", "popupContent__contentArea__frame").attr("class","myStampImg");

				if (usePc) {
					divImg.attr("src", "img/pc/desktop/default/mySticker_howto_pc.png");
				} else {
					divImg.attr("src", "img/sp/common/default/mySticker_howto_sp.png");
				}

				let divMesFoot = $("<p>").attr("class", "popupContent__contentArea__bottomMsg").html(
					"※元画像が長辺1000px以上の場合は、長辺1000px以下に縮小されます。<br>" +
					"※元画像サイズが小さい場合や、プリント時に10cmを超えるサイズに拡大した場合、画質が荒くなる可能性があります。<br>" +
					"※本機能のJPEG画像は、色補正の指定はできません。<br>"
				);
				let divMesFoot2 = $("<p>").attr("class", "popupContent__contentArea__bottomMsg").css('color','red').html(
					"※キャラクター年賀状は、企業ロゴ・ブランドロゴを追加した法人用途（会社用・店用・団体用）では、利用できません。<br>"
				);
				divMes.append(divMesHead);
				divMes.append(divImg);
				divMes.append(divMesFoot);
				divMes.append(divMesFoot2);
				section.append(divMes);

				// 次回からは表示しない
				let checkdiv = $("<div>").attr("class", "ConfirmCheckboxArea")
				let checkNext = $("<input>").attr("type", "checkbox").attr("id", "ConfirmMyStampCheckbox");
				let checkLabel = $("<label>").attr("for", "ConfirmMyStampCheckbox").html(" 次回からは表示しない");
				checkdiv.append(checkNext);
				checkdiv.append(checkLabel);
				section.append(checkdiv);

				// フッター
				let footer = $("<footer>").attr("class", "c-modalDialog__footer t-footer");
				let buttonOK = $("<button>").attr("id", "myStampHowToDlg_okBtn").attr("class", "c-modalDialog__footerBtn t-btn").text("OK");
				let buttonCANCEL = $("<button>").attr("id", "myStampHowToDlg_cancelBtn").attr("class", "c-modalDialog__footerBtn t-btn").text("キャンセル");
				footer.append(buttonCANCEL);
				footer.append(buttonOK);
				section.append(footer);

				dialogParent.append(section);
			}

			// 関数の追加
			$("#myStampHowToDlg_okBtn").off();
			$("#myStampHowToDlg_okBtn").on('click', () => {
				dialogUtil.closeMyStampHowToDialog();
				res($("#ConfirmMyStampCheckbox").prop("checked"));
				okFunc();
			});
			$('#myStampHowToDlg_cancelBtn').off('click');
			$('#myStampHowToDlg_cancelBtn').on('click', () => {
				dialogUtil.closeMyStampHowToDialog();
				res($("#ConfirmMyStampCheckbox").prop("checked"));
				cancelFunc()
			});


			$("#myStampHowToDlg").show();            
		});
	}
	export function closeMyStampHowToDialog(): void {
		/*alert("OKボタンイベント");*/
		let body = $("body");
		body.removeClass().removeClass("anmDialog");

		$("#myStampHowToDlg").removeClass("c-modalDialog__panel--hasClose");
	}

	/**
	 * 手書き手順ダイアログ
	 */
	export function showTegakiStampHowToDlg(usePc: boolean): es6promise.Promise<any> {

		return new es6promise.Promise((res, rej) => {
			let body = $("body");
			body.removeClass().addClass("anmDialog");

			let dlg = $("#tegakiConfirmDlg");
			let dlgBody = 
'<section class="c-modalDialog__content u-positionOrigin">\
	<header class="c-modalDialog__header is-hidden">\
		<h1 class="dlgHeader">「手書き機能」手順</h1>\
	</header>\
	<h3 class="popupContentTitle">「手書き機能」手順<span class="popupContentIcon" /></h3>\
	<div class="popupContentContentArea">\
		<img id="tegakiConfirmImage" class="popupContent__contentArea__frame">\
	</div>\
	<div class="ConfirmCheckboxArea">\
		<input type="checkbox" id="tegakiConfirmBottomCheckbox">\
		<label for="tegakiConfirmBottomCheckbox"> 次回からは表示しない</label>\
	</div>\
	<footer class="c-modalDialog__footer t-footer">\
		<button id="tegakiConfirmCancelBtn" class="c-modalDialog__footerBtn t-btn">キャンセル</button>\
		<button id="tegakiConfirmOkBtn" class="c-modalDialog__footerBtn t-btn">OK</button>\
	</footer>\
</section>'

			//$(dlg).appendTo("#tegakiConfirmDlg");
			dlg.html(dlgBody);

			dlg.addClass("is-information");
			dlg.addClass("c-modalDialog__panel--hasClose");

			if (usePc) {
				$("#tegakiConfirmImage").attr("src", "img/pc/desktop/default/fontgenic_howto_pc.png");
			} else {
				$("#tegakiConfirmImage").attr("src", "img/sp/common/default/fontgenic_howto_sp.png");
				$('header').removeClass("is-hidden");
				$('h3').remove();
			}

			//イベント追加
			let closeFnc = () => {
				let body = $("body");
				body.removeClass().removeClass("anmDialog");
				dlg.removeClass("c-modalDialog__panel--hasClose");
			}

			$("#tegakiConfirmCancelBtn").off();
			$("#tegakiConfirmCancelBtn").on('click', () => {
				closeFnc();
				res({ btn: false, chk: $("#tegakiConfirmBottomCheckbox").prop("checked") });
			});

			$("#tegakiConfirmOkBtn").off();
			$("#tegakiConfirmOkBtn").on('click', () => {
				closeFnc();
				res({ btn: true, chk: $("#tegakiConfirmBottomCheckbox").prop("checked") });
			});

			$("#tegakiConfirmDlg").show();

		});
	}

	/**
	 * ガイダンス１表示（PC用）
	 */
	export function showGuidance1Dlg(guidanceImgSrcList: string[]): es6promise.Promise < any > {

		return new es6promise.Promise((res, rej) => {
			$("body").removeClass().addClass("anmDialog");

			const dlg = $("#guidance1Dlg");
			const htmlStr =
`<section class="c-modalDialog__content u-positionOrigin" >
	<h3 class="guidanceContentTitle">
		おすすめ機能のご案内
		<button id="guidance1SkipBtn" class="c-modalDialog__footerBtn t-btn" v-on:click="btnClickGuidance1Skip($event)"> 閉じる </button>
	</h3>
	<div class="popupContentContentArea">
		<p class="guidanceContent__contentArea__topMsg">
			写真入りデザインは、写真を自分のお好みにあわせて<br>
			レイアウトができます
			<label
				class="c-toolBarBtnList__btn c-toolBarBtnList__btn--adjustImage is-active guidanceContentIcon">画像編集</label>
		</p>
		<img id="guidance1Image" class="popupContent__contentArea__frame" src="">
	</div>
	<footer class="c-modalDialog__footer t-footer" >
		<button id="guidance1NextBtn" class="c-modalDialog__footerBtn t-btn" v-on:click="btnClickGuidance1Next($event)"> 次へ </button>
	</footer>
</section>`;

			dlg.html(htmlStr);
			dlg.addClass("is-information");
			dlg.addClass("c-modalDialog__panel--hasClose");
			$("#guidance1Image").attr("src", guidanceImgSrcList[0]);

			$("#guidance1NextBtn").off().on('click', () => {
				dialogUtil.showGuidance2Dlg(guidanceImgSrcList)
					.then(() => {
						res();
					})
					.catch(() => rej());
				setTimeout(() => dlg.removeClass("c-modalDialog__panel--hasClose"), 300);
			});
			$("#guidance1SkipBtn").off().on('click', () => {
				dialogUtil.closeGuidanceDlg();
				res();
			});

			dlg.show();
		});
	}

	/**
	 * ガイダンス２表示（PC用）
	 */
	export function showGuidance2Dlg(guidanceImgSrcList: string[]): es6promise.Promise<any> {

		return new es6promise.Promise((res, rej) => {

			const dlg = $("#guidance2Dlg");
			const htmlStr =
`<section class="c-modalDialog__content u-positionOrigin" >
	<h3 class="guidanceContentTitle">
		おすすめ機能のご案内
		<button id="guidance2SkipBtn" class="c-modalDialog__footerBtn t-btn" v-on:click="btnClickGuidance1Skip($event)"> 閉じる </button>
	</h3>
	<div class="popupContentContentArea">
		<p class="guidanceContent__contentArea__topMsg">
			あいさつ文は、例文から選択か、オリジナルメッセージを入力できます<br>
			差出人情報は、印字内容を入力すると自動でレイアウトします
<ul class="guidanceContentIcon" style="top: 10px;">
<li class="c-toolBarBtnList__item"><label class="c-toolBarBtnList__btn c-toolBarBtnList__btn--greeting is-active">挨拶文編集</label></li>
<li class="c-toolBarBtnList__item"><label class="c-toolBarBtnList__btn c-toolBarBtnList__btn--sender is-active">差出人情報編集</label></li>
</ul>

		</p>
		<img id="guidance2Image" class="popupContent__contentArea__frame" src="">
	</div>
	<footer class="c-modalDialog__footer t-footer" >
		<button id="guidance2PrevBtn" class="c-modalDialog__footerBtn t-btn" v-on:click="btnClickGuidance1Prev($event)"> 戻る </button>
		<button id="guidance2NextBtn" class="c-modalDialog__footerBtn t-btn" v-on:click="btnClickGuidance1Next($event)"> 次へ </button>
	</footer>
</section>`;

			dlg.html(htmlStr);
			dlg.addClass("is-information");
			dlg.addClass("c-modalDialog__panel--hasClose");
			$("#guidance2Image").attr("src", guidanceImgSrcList[1]);

			$("#guidance2PrevBtn").off().on('click', () => {
				dialogUtil.showGuidance1Dlg(guidanceImgSrcList)
					.then(() => {
						res();
					})
					.catch(() => rej());
				setTimeout(() => dlg.removeClass("c-modalDialog__panel--hasClose"), 300);
			});
			$("#guidance2NextBtn").off().on('click', () => {
				dialogUtil.showGuidance3Dlg(guidanceImgSrcList)
					.then(() => {
						res();
					})
					.catch(() => rej());
				setTimeout(() => dlg.removeClass("c-modalDialog__panel--hasClose"), 300);
			});
			$("#guidance2SkipBtn").off().on('click', () => {
				dialogUtil.closeGuidanceDlg();
				res();
			});

			dlg.show();
		});
	}

	/**
	 * ガイダンス３表示（PC用）
	 */
	export function showGuidance3Dlg(guidanceImgSrcList: string[]): es6promise.Promise<any> {

		return new es6promise.Promise((res, rej) => {

			const dlg = $("#guidance3Dlg");
			const htmlStr =
`<section class="c-modalDialog__content u-positionOrigin" >
	<h3 class="guidanceContentTitle">
		おすすめ機能のご案内
		<button id="guidance3SkipBtn" class="c-modalDialog__footerBtn t-btn" v-on:click="btnClickGuidance1Skip($event)"> 閉じる </button>
	</h3>
	<div class="popupContentContentArea">
		<p class="guidanceContent__contentArea__topMsg" style="margin-left: 90px;">
			お好みのスタンプで、ポストカードを自分らしくアレンジできます<br>&nbsp;
			<label
				class="c-toolBarBtnList__btn c-toolBarBtnList__btn--stamp c-toolBarBtnList__btn--small is-active guidanceContentIcon"
				style="position: absolute; transform: scale(0.7); top: 63px;">スタンプ</label>
		</p>
		<img id="guidance3Image" class="popupContent__contentArea__frame" src="">
	</div>
	<footer class="c-modalDialog__footer t-footer" >
		<button id="guidance3PrevBtn" class="c-modalDialog__footerBtn t-btn" v-on:click="btnClickGuidance1Prev($event)"> 戻る </button>
		<button id="guidance3NextBtn" class="c-modalDialog__footerBtn t-btn" v-on:click="btnClickGuidance1Next($event)"> 次へ </button>
	</footer>
</section>`;

			dlg.html(htmlStr);
			dlg.addClass("is-information");
			dlg.addClass("c-modalDialog__panel--hasClose");
			$("#guidance3Image").attr("src", guidanceImgSrcList[2]);

			$("#guidance3PrevBtn").off().on('click', () => {
				dialogUtil.showGuidance2Dlg(guidanceImgSrcList)
					.then(() => {
						res();
					})
					.catch(() => rej());
				setTimeout(() => dlg.removeClass("c-modalDialog__panel--hasClose"), 300);
			});
			$("#guidance3NextBtn").off().on('click', () => {
				dialogUtil.showGuidance4Dlg(guidanceImgSrcList)
					.then(() => {
						res()
					})
					.catch(() => rej());
				setTimeout(() => dlg.removeClass("c-modalDialog__panel--hasClose"), 300);
			});
			$("#guidance3SkipBtn").off().on('click', () => {
				dialogUtil.closeGuidanceDlg();
				res();
			});

			dlg.show();
		});
	}

	/**
	 * ガイダンス４表示（PC用）
	 */
	export function showGuidance4Dlg(guidanceImgSrcList: string[]): es6promise.Promise<any> {

		return new es6promise.Promise((res, rej) => {

			const dlg = $("#guidance4Dlg");
			const htmlStr =
`<section class="c-modalDialog__content u-positionOrigin" >
	<h3 class="guidanceContentTitle">
		おすすめ機能のご案内
		<button id="guidance4SkipBtn" class="c-modalDialog__footerBtn t-btn" v-on:click="btnClickGuidance1Skip($event)"> 閉じる </button>
	</h3>
	<div class="popupContentContentArea">
		<p class="guidanceContent__contentArea__topMsg">
			お手持ちの画像（写真、イラスト）をスタンプにできます<br>
			写真なしタイプにも使えます
			<label
				class="c-toolBarBtnList__btn c-toolBarBtnList__btn--mystamp is-active guidanceContentIcon">写真スタンプ</label>
		</p>
		<img id="guidance4Image" class="popupContent__contentArea__frame" src="">
	</div>
	<footer class="c-modalDialog__footer t-footer" >
		<button id="guidance4PrevBtn" class="c-modalDialog__footerBtn t-btn" v-on:click="btnClickGuidance1Prev($event)"> 戻る </button>
		<button id="guidance4NextBtn" class="c-modalDialog__footerBtn t-btn" v-on:click="btnClickGuidance1Next($event)"> 次へ </button>
	</footer>
</section>`;

			dlg.html(htmlStr);
			dlg.addClass("is-information");
			dlg.addClass("c-modalDialog__panel--hasClose");
			$("#guidance4Image").attr("src", guidanceImgSrcList[3]);

			$("#guidance4PrevBtn").off().on('click', () => {
				dialogUtil.showGuidance3Dlg(guidanceImgSrcList)
					.then(() => {
						res();
					})
					.catch(() => rej());
				setTimeout(() => dlg.removeClass("c-modalDialog__panel--hasClose"), 300);
			});
			$("#guidance4NextBtn").off().on('click', () => {
				dialogUtil.showGuidance5Dlg(guidanceImgSrcList)
					.then(() => {
						res()
					})
					.catch(() => rej());
				setTimeout(() => dlg.removeClass("c-modalDialog__panel--hasClose"), 300);
			});
			$("#guidance4SkipBtn").off().on('click', () => {
				dialogUtil.closeGuidanceDlg();
				res();
			});

			dlg.show();
		});
	}

	/**
	 * ガイダンス５表示（PC用）
	 */
	export function showGuidance5Dlg(guidanceImgSrcList: string[]): es6promise.Promise<any> {

		return new es6promise.Promise((res, rej) => {

			const dlg = $("#guidance5Dlg");
			const htmlStr =
`<section class="c-modalDialog__content u-positionOrigin" >
	<h3 class="guidanceContentTitle">
		おすすめ機能のご案内
		<button id="guidance5FinishBtn" class="c-modalDialog__footerBtn t-btn" v-on:click="btnClickGuidance2Finish($event)"> 閉じる </button>
		<!--宛名印刷機能を、上手に使おう！<span class="popupContentIcon" /> -->
	</h3>
	<div class="popupContentContentArea">
		<p class="guidanceContent__contentArea__topMsg" style="margin-left: 14px;">
			「はがき種類・枚数」選択後に、宛名印刷の有無を選択できます<br>
			「ひとことコメント」機能で、相手ごとに個別メッセージを追記できます
		</p>
		<img id="guidance5Image" class="popupContent__contentArea__frame" src="">
	</div>
	<footer class="c-modalDialog__footer t-footer" >
		<button id="guidance5PrevBtn" class="c-modalDialog__footerBtn t-btn" v-on:click="btnClickGuidance1Prev($event)"> 戻る </button>
	</footer>
</section>`;

			dlg.html(htmlStr);
			dlg.addClass("is-information");
			dlg.addClass("c-modalDialog__panel--hasClose");
			$("#guidance5Image").attr("src", guidanceImgSrcList[4]);

			$("#guidance5PrevBtn").off().on('click', () => {
				dialogUtil.showGuidance4Dlg(guidanceImgSrcList)
					.then(() => {
						res();
					})
					.catch(() => rej());
				setTimeout(() => dlg.removeClass("c-modalDialog__panel--hasClose"), 300);
			});
			$("#guidance5FinishBtn").off().on('click', () => {
				dialogUtil.closeGuidanceDlg();
				res();
			});

			dlg.show();
		});
	}

	/**
	 * ガイダンス非表示（PC用）
	 */
	export function closeGuidanceDlg(): void {

		$("#guidance1Dlg").removeClass("c-modalDialog__panel--hasClose");
		$("#guidance2Dlg").removeClass("c-modalDialog__panel--hasClose");
		$("#guidance3Dlg").removeClass("c-modalDialog__panel--hasClose");
		$("#guidance4Dlg").removeClass("c-modalDialog__panel--hasClose");
		$("#guidance5Dlg").removeClass("c-modalDialog__panel--hasClose");
		if ($(".c-modalDialog .c-modalDialog__panel--hasClose").length == 0) {
			$("body").removeClass().removeClass("anmDialog");
		}
	}
}